// components
import Checkbox, { CheckboxProps } from './components/checkbox'
import ErrorMessage, { ErrorMessageProps } from './components/error-message'
import Select, { SelectProps } from './components/select'
import Text, { TextProps } from './components/text'
import Textarea, { TextareaProps } from './components/textarea'

// styles
import styles from './field.module.scss'

export type BaseFieldProps = {
	readonly errorMessage?: ErrorMessageProps['message']
	readonly gridColSpan?: number
	readonly gridColStart?: number
	readonly label?: string
}

type FieldProps = CheckboxProps | SelectProps | TextProps | TextareaProps

const Field = (props: FieldProps): JSX.Element => {
	const isOfType = (types: string[]): boolean => {
		return types.find((type) => type === props.type) !== undefined
	}

	const { errorMessage, gridColSpan, gridColStart, ...fieldProps } = props

	return (
		<div
			className={styles.field}
			data-grid-colspan={gridColSpan}
			data-grid-colstart={gridColStart}
		>
			{/* Checkbox, Radio */}
			{isOfType(['checkbox', 'radio']) && (
				<Checkbox {...(fieldProps as CheckboxProps)} />
			)}

			{/* Select */}
			{isOfType(['select']) && (
				<Select {...(fieldProps as SelectProps)} />
			)}

			{/* Standard Textfields */}
			{isOfType([
				'color',
				'date',
				'datetime-local',
				'email',
				'hidden',
				'month',
				'number',
				'password',
				'tel',
				'text',
				'time',
				'url',
				'week',
			]) && <Text {...(fieldProps as TextProps)} />}

			{/* Textarea */}
			{isOfType(['textarea']) && (
				<Textarea {...(fieldProps as TextareaProps)} />
			)}

			<ErrorMessage message={errorMessage} />
		</div>
	)
}
export default Field
